// css tag
module.exports = (params, ...values) => {
    let output = '';
    params.forEach((param, i) => {
        output += param;
        if (values && i < values.length)
            output += typeof values[i] === 'function' ? values[i]() : values[i];
    });
    return output;
};
